var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanetB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 100,
    viewBox: "0 0 140 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3244 70.3821C41.2742 67.6759 39.6026 64.6265 38.4099 61.2915C33.0589 65.9796 30.3014 69.6711 31.297 71.3956C32.2788 73.0961 36.7419 72.5924 43.3244 70.3821ZM102.091 36.4716C107.336 31.8507 110.029 28.216 109.043 26.5089C108.044 24.7788 103.442 25.3303 96.6703 27.6393C98.879 30.2422 100.72 33.2061 102.091 36.4716ZM95.1637 25.9779C112.282 18.4289 124.849 15.3763 126.927 18.9743C129.039 22.6335 119.77 32.25 104.204 43.546C107.425 60.9137 96.7854 78.1122 79.4324 82.7619C68.2004 85.7715 56.7755 82.8217 48.5148 75.8507C30.3454 84.0706 16.8411 87.521 14.6809 83.7795C12.5558 80.0986 21.9483 70.3898 37.6812 59.007C37.6423 58.8687 37.6042 58.73 37.5669 58.5908C32.6808 40.3553 43.5025 21.6115 61.738 16.7253C74.1566 13.3978 86.8109 17.3552 95.1637 25.9779Z",
    fill: "#004B8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetB);
export default __webpack_public_path__ + "static/media/PlanetB.2cfe83e7490a4a18d2bc13ad7a2b63ca.svg";
export { ForwardRef as ReactComponent };